import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import carriereDescription from "./pages/carriereDescription";
import Home from "./home/index"
import Solutions from "./pages/solutions";
import Contact from "./pages/contact";
import Media from "./pages/media";
import Blog from "./pages/blog";
import PostulateForm from "./pages/FormPostulate";
import Carrieres from "./pages/carrieres";
import internshipDescription from "./pages/internshipDescription";
import PostulateFormIntern from "./pages/FormPostulerInternship";
import TagManager from 'react-gtm-module'



// class App extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//     };
//   }

//   render() {

  function App() {
    // window.dataLayer.push({
    //   event: 'pageview'
    // });
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_IDGTM,
      auth: process.env.REACT_APP_GTM_ENV,
      preview: process.env.REACT_APP_GTM_PREV,
      dataLayer: {
            userProject: 'Chifco_website',
            x:"haama"
        }
    }
    TagManager.initialize(tagManagerArgs);
    return (
      <Router>
        <div>
          {/* <Headder /> */}
          <Route path="" exact component={Home}/>
          <Route path="/solutions" component={Solutions} />
          <Route path="/contact" component={Contact} />
          <Route path="/carrieres" component={Carrieres} exact />
          <Route path="/carrieres/:id" component={carriereDescription} />
          <Route path="/internShip/:id" component={internshipDescription} />
          <Route path="/medias" component={Media} />
          <Route path="/blog" component={Blog} />
          <Route path="/postuler/:id" component={PostulateForm}/>
          <Route path="/postulerStage/:id" component={ PostulateFormIntern}/>
         

         {/* <Route path="/apropos" component={Apropos} />
          <Route path="/valeurs" component={NosValeurs} />
          <Route path="/solutions" component={Solutions} />
          
          <Route path="/carrieres" component={Carrieres} />

          <Route path="/contact" component={Contact} />
          <Route path="/carouselResp" component={CarouselResponsive} />*/}
        </div>
      </Router>
    );
  }
//}



export default App;



// WEBPACK FOOTER //
// ./src/App.js